{
  "slug": "intelligence-research-how-to-read-a-new-study",
  "title": "New Intelligence Study? How to Read the Evidence",
  "description": "Check preregistration, sampling, measurement, effect size, uncertainty, replication, and causal claims.",
  "category": "Research explainers",
  "sections": [
    {
      "heading": "Research question",
      "paragraphs": [
        "Check preregistration, sampling, measurement, effect size, uncertainty, replication, and causal claims.",
        "Good summaries state what was measured, who participated, when, and whether the design supports causation."
      ]
    },
    {
      "heading": "Evidence checklist",
      "paragraphs": [
        "Look for transparent methods, validated measures, power, effect sizes with intervals, missing-data handling, and replication.",
        "Statistical significance does not automatically imply a useful effect."
      ]
    },
    {
      "heading": "Reporting",
      "paragraphs": [
        "Separate findings from interpretation, disclose limitations and conflicts, and link the primary paper.",
        "Publication begins evaluation; it is not the final word."
      ]
    }
  ],
  "related": ["how-is-iq-measured", "iq-vs-intelligence", "historical-iq-trends"],
  "sources": [],
  "faqs": [],
  "summary": "Check preregistration, sampling, measurement, effect size, uncertainty, replication, and causal claims. Content reviewed 18 July 2026."
}
